export default __webpack_public_path__ + "static/media/legend.9527bbb6.svg";